import shop from "shop/shop"

const checkCartSize = () => {
  if (shop.cart.size === 0) {
    // browserHistory.push("/checkout")
    // shop.toast("Sie haben keine Produkte im Warenkorb")
    return false
  }
  return true
}

const checkMinCartValue = (value = shop.config.MIN_ORDER_VALUE || 0) => {
  if (shop.cart.sum < value && shop.cart.data && shop.cart.data.extras && shop.cart.data.extras.is_quotation_request !== true) {
    shop.toast(`Sie haben den Mindestbestellwert (${value} EUR) noch nicht erreicht`)
    return false
  }
  return true
}

export {checkCartSize, checkMinCartValue}



// WEBPACK FOOTER //
// ./src/pages/checkout/check.js